module.exports = __webpack_public_path__ + "07_bob_black.da9bdf50.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_bob_black.png
// module id = UMRw
// module chunks = 0